import React from "react";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/Endpoint";
import { tw } from "@careinfo/tailwind";
import EditIcon from "../../Icons/EditIcon";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import { useParams } from "react-router-dom";
import Spinner from "../../components/reusable/Spinner";

const EditShipviaComponent = loadable(
  () => import("../../components/Shipvia/EditShipvia")
);

const EditShipvia = () => {
  const { id } = useParams();

  const { data, isLoading } = useGetHook({
    queryKey: ["ship-via", `ship-via-${id}`],
    url: `${APIS.SHIP_VIA}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading: mutateAsyncLoading } = usePatchHook({
    queryKey: ["ship-via"],
    navigateURL: "/",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.SHIP_VIA}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <EditIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Ship Via
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditShipviaComponent
          handleEdit={handleEdit}
          isLoading={mutateAsyncLoading}
          data={data}
        />
      )}
    </div>
  );
};

export default EditShipvia;
